var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClosePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 4.00004C6.7441 4.00004 6.48794 4.09751 6.29294 4.29301L4.29294 6.29301C3.90194 6.68401 3.90194 7.31707 4.29294 7.70707L11.5859 15L4.29294 22.293C3.90194 22.684 3.90194 23.3171 4.29294 23.7071L6.29294 25.7071C6.68394 26.0981 7.31701 26.0981 7.70701 25.7071L15 18.4141L22.2929 25.7071C22.6829 26.0981 23.317 26.0981 23.707 25.7071L25.707 23.7071C26.098 23.3161 26.098 22.683 25.707 22.293L18.414 15L25.707 7.70707C26.098 7.31707 26.098 6.68301 25.707 6.29301L23.707 4.29301C23.316 3.90201 22.6829 3.90201 22.2929 4.29301L15 11.586L7.70701 4.29301C7.51151 4.09751 7.25585 4.00004 6.99998 4.00004Z",
    fill: "#EB7F46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePrimary);
export default __webpack_public_path__ + "static/media/close-primary.6cbe64cd4feaa43a5c8464ea97b4d488.svg";
export { ForwardRef as ReactComponent };